import React from "react";
import { Box, Break, Link, Picture, Text } from "~/components-shared";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Collapsable from "~/components/Collapsable";
import { helpers } from "~/lib/helpers";
import Markdown from "~/components/Markdown";
const Wrapper = styled.div`
  padding-left: 1em;
  margin-bottom: 1em;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 3px;
    background-color: ${_ref => {
  let {
    $color,
    theme
  } = _ref;
  return $color || theme.colors.primary.main;
}};
    width: 3px;
    height: 100%;
  }
`;
const SlackFootprintBotTemplates = _ref2 => {
  let {
    footprint
  } = _ref2;
  const {
    t
  } = useTranslation();
  const {
    data: {
      attachments,
      blocks,
      botName
    },
    aiAnalysis
  } = footprint;

  // Legacy bots
  if (attachments) {
    // Clickup bot template
    if (botName.toLowerCase().includes("clickup")) {
      const attachmentBlocks = attachments?.[0]?.blocks;
      // Clickup bot task template
      if (attachmentBlocks[0]?.type === "section") {
        const color = attachments[0]?.color;
        const titleBlock = attachmentBlocks[0]?.text?.text?.replace(/[<>*]/g, "").split("|");
        const title = titleBlock?.[1];
        const url = titleBlock?.[0];
        const elements = attachmentBlocks?.[1]?.elements;
        const project = elements?.[1]?.text;
        const statusIndex = elements?.findIndex(element => element.alt_text?.toLowerCase().includes("status"));
        const assigneesIndex = elements?.findIndex(element => element.alt_text?.toLowerCase().includes("assignees"));
        const priorityIndex = elements?.findIndex(element => element.alt_text?.toLowerCase().includes("priority"));
        return /*#__PURE__*/React.createElement(Wrapper, {
          $color: color
        }, title && /*#__PURE__*/React.createElement(Link, {
          href: url,
          weight: "semiBold",
          fontSize: 4,
          display: "block",
          s: {
            mb: 1
          }
        }, title), elements && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          wrap: "wrap",
          gap: 5
        }, project && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          gap: 1,
          wrap: "nowrap"
        }, /*#__PURE__*/React.createElement(Picture, {
          width: "1.5rem",
          height: "1.5rem",
          src: "https://search.clickup-prod.com/media/app-icons/clickup/logo_alpha.png"
        }), /*#__PURE__*/React.createElement(Text, {
          s: {
            mt: 0.75
          },
          color: "textSecondary"
        }, project)), statusIndex !== -1 && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          gap: 1,
          wrap: "nowrap"
        }, /*#__PURE__*/React.createElement(Picture, {
          width: "1.5rem",
          height: "1.5rem",
          src: elements[statusIndex]?.image_url
        }), /*#__PURE__*/React.createElement(Text, {
          s: {
            mt: 0.75
          },
          color: "textSecondary"
        }, elements[statusIndex + 1]?.text)), assigneesIndex !== -1 && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          gap: 1,
          wrap: "nowrap"
        }, /*#__PURE__*/React.createElement(Picture, {
          width: "1.5rem",
          height: "1.5rem",
          src: elements[assigneesIndex]?.image_url
        }), /*#__PURE__*/React.createElement(Text, {
          s: {
            mt: 0.75
          },
          color: "textSecondary"
        }, elements[assigneesIndex + 1]?.text)), priorityIndex !== -1 && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          gap: 1,
          wrap: "nowrap"
        }, /*#__PURE__*/React.createElement(Picture, {
          width: "1.5rem",
          height: "1.5rem",
          src: elements[priorityIndex]?.image_url
        }), /*#__PURE__*/React.createElement(Text, {
          s: {
            mt: 0.75
          },
          color: "textSecondary"
        }, elements[priorityIndex + 1]?.text))));
      }

      // Clickup bot comment template
      if (attachmentBlocks[0]?.type === "context") {
        const color = attachments[0]?.color;
        const titleElements = attachmentBlocks?.[0]?.elements;
        const title = helpers.replaceSlackFormatting(titleElements?.[0]?.text?.replace(":speech_balloon:", ""));
        const text = attachmentBlocks?.[1]?.text?.text;
        const metaElements = attachmentBlocks?.[2]?.elements;
        const project = metaElements?.[1]?.text;
        return /*#__PURE__*/React.createElement(Wrapper, {
          $color: color
        }, title && /*#__PURE__*/React.createElement(Markdown, {
          weight: "semiBold",
          fontSize: 4,
          lineHeight: 6.5,
          display: "block",
          s: {
            mb: 3
          },
          text: title
        }), !!text && /*#__PURE__*/React.createElement(Collapsable, null, /*#__PURE__*/React.createElement(Text, {
          fontSize: 4,
          display: "block",
          element: "p",
          s: {
            mb: 1
          }
        }, text)), metaElements && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          wrap: "wrap",
          gap: 5
        }, project && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          gap: 1,
          wrap: "nowrap"
        }, /*#__PURE__*/React.createElement(Picture, {
          width: "1.5rem",
          height: "1.5rem",
          src: "https://search.clickup-prod.com/media/app-icons/clickup/logo_alpha.png"
        }), /*#__PURE__*/React.createElement(Text, {
          s: {
            mt: 0.75
          },
          color: "textSecondary"
        }, project))));
      }
    }

    // Zendesk bot template
    if (botName.toLowerCase().includes("zendesk")) {
      const attachment = attachments?.[0];
      if (attachment) {
        const color = `#${attachment.color}`;
        const title = attachment.text;
        const description = attachment.fields?.[0]?.value;
        const footerElements = attachment.footer?.split(" | ") || [];
        const ticketIndex = footerElements?.findIndex(element => element.toLowerCase().includes("ticket #"));
        const statusIndex = footerElements?.findIndex(element => element.toLowerCase().includes("status"));
        const accountIndex = footerElements?.findIndex(element => element.toLowerCase().includes("account"));
        return /*#__PURE__*/React.createElement(Wrapper, {
          $color: color
        }, title && /*#__PURE__*/React.createElement(Text, {
          weight: "semiBold",
          fontSize: 4,
          lineHeight: 6.5,
          display: "block",
          s: {
            mb: 3
          }
        }, title), description && /*#__PURE__*/React.createElement(Collapsable, null, /*#__PURE__*/React.createElement(Markdown, {
          fontSize: 4,
          display: "block",
          s: {
            mb: 1
          },
          linkColor: "text",
          text: helpers.replaceSlackFormatting(description)
        })), footerElements.length && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          wrap: "wrap",
          gap: 5
        }, footerElements[ticketIndex] && /*#__PURE__*/React.createElement(Markdown, {
          s: {
            mt: 0.75
          },
          color: "textSecondary",
          weight: "semiBold",
          linkColor: "textSecondary",
          text: helpers.replaceSlackFormatting(footerElements[ticketIndex])
        }), footerElements[statusIndex] && /*#__PURE__*/React.createElement(Text, {
          s: {
            mt: 0.75
          },
          color: "textSecondary",
          weight: "semiBold"
        }, footerElements[statusIndex]), footerElements[accountIndex] && /*#__PURE__*/React.createElement(Text, {
          s: {
            mt: 0.75
          },
          color: "textSecondary",
          weight: "semiBold"
        }, footerElements[accountIndex])));
      }
    }
    if (botName.toLowerCase().includes("gitlab")) {
      if (attachments[0]?.text) {
        const color = `#${attachments[0]?.color}`;
        const text = helpers.replaceSlackFormatting(attachments[0]?.text);
        return /*#__PURE__*/React.createElement(Wrapper, {
          $color: color
        }, !!text && /*#__PURE__*/React.createElement(Collapsable, null, /*#__PURE__*/React.createElement(Markdown, {
          fontSize: 4,
          display: "block",
          element: "p",
          s: {
            mb: 1
          },
          text: text
        })));
      }
    }
    if (botName.toLowerCase().includes("github")) {
      const attachment = attachments?.[0];
      if (attachment) {
        const color = `#${attachment.color}`;
        const {
          title
        } = attachment;
        const description = attachment.text;
        const {
          fields,
          footer,
          pretext
        } = attachment;
        const fieldElements = fields || [];
        const reviewersIndex = fieldElements.findIndex(element => element.title.toLowerCase().includes("reviewers"));
        const assigneesIndex = fieldElements.findIndex(element => element.title.toLowerCase().includes("assignees"));
        const labelsIndex = fieldElements.findIndex(element => element.title.toLowerCase().includes("labels"));
        const commentsIndex = fieldElements.findIndex(element => element.title.toLowerCase().includes("comments"));
        return /*#__PURE__*/React.createElement(Wrapper, {
          $color: color
        }, title && /*#__PURE__*/React.createElement(Text, {
          weight: "semiBold",
          fontSize: 4,
          lineHeight: 6.5,
          display: "block",
          s: {
            mb: 1
          }
        }, /*#__PURE__*/React.createElement(Markdown, {
          fontSize: 4,
          display: "block",
          s: {
            mb: 1
          },
          linkColor: "text",
          text: helpers.replaceSlackFormatting(title)
        })), description && /*#__PURE__*/React.createElement(Collapsable, null, /*#__PURE__*/React.createElement(Markdown, {
          fontSize: 4,
          display: "block",
          s: {
            mb: 1,
            mt: 2
          },
          linkColor: "text",
          text: helpers.replaceSlackFormatting(description)
        })), /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          wrap: "wrap",
          s: {
            mb: 2
          }
        }, fieldElements[reviewersIndex] && /*#__PURE__*/React.createElement(Markdown, {
          s: {
            mr: 5,
            mt: 0.75
          },
          color: "textSecondary",
          weight: "semiBold",
          linkColor: "textSecondary",
          text: `Reviewers: ${helpers.replaceSlackFormatting(fieldElements[reviewersIndex].value)}`
        }), fieldElements[assigneesIndex] && /*#__PURE__*/React.createElement(Markdown, {
          s: {
            mr: 5,
            mt: 0.75
          },
          color: "textSecondary",
          weight: "semiBold",
          linkColor: "textSecondary",
          text: `Assignees: ${helpers.replaceSlackFormatting(fieldElements[assigneesIndex].value)}`
        }), fieldElements[labelsIndex] && /*#__PURE__*/React.createElement(Text, {
          s: {
            mr: 5,
            mt: 0.75
          },
          color: "textSecondary",
          weight: "semiBold"
        }, "Labels: ", fieldElements[labelsIndex].value), fieldElements[commentsIndex] && /*#__PURE__*/React.createElement(Text, {
          s: {
            mr: 5,
            mt: 0.75
          },
          color: "textSecondary",
          weight: "semiBold"
        }, "Comments: ", fieldElements[commentsIndex].value), footer && /*#__PURE__*/React.createElement(Markdown, {
          s: {
            mr: 5,
            mt: 0.75
          },
          color: "textSecondary",
          weight: "semiBold",
          linkColor: "textSecondary",
          text: `Repository: ${helpers.replaceSlackFormatting(footer)}`
        })), pretext && /*#__PURE__*/React.createElement(Markdown, {
          fontSize: 4,
          linkColor: "text",
          text: helpers.replaceSlackFormatting(pretext)
        }));
      }
    }
  }

  // New Slack bot approach
  if (blocks) {
    if (botName.toLowerCase().includes("jira")) {
      if (blocks[0]?.text) {
        const title = helpers.replaceSlackFormatting(blocks[0].text.text);
        const elements = blocks[1]?.elements;
        const status = helpers.replaceSlackFormatting(elements?.find(element => element.text?.toLowerCase().includes("status"))?.text);
        const typeImage = elements?.find(element => element.image_url?.toLowerCase().includes("jira-issuetype"))?.image_url;
        const type = helpers.replaceSlackFormatting(elements?.find(element => element.text?.toLowerCase().includes("type"))?.text);
        const assigneeImage = elements?.find(element => element.image_url?.toLowerCase().includes("avatar-management"))?.image_url;
        const assignee = helpers.replaceSlackFormatting(elements?.find(element => element.text?.toLowerCase().includes("assignee"))?.text);
        const priorityImage = elements?.find(element => element.image_url?.toLowerCase().includes("jira-priority"))?.image_url;
        const priority = helpers.replaceSlackFormatting(elements?.find(element => element.text?.toLowerCase().includes("priority"))?.text);
        return /*#__PURE__*/React.createElement(Wrapper, null, title && /*#__PURE__*/React.createElement(Markdown, {
          weight: "semiBold",
          fontSize: 4,
          display: "block",
          s: {
            mb: 1
          },
          text: title
        }), elements && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          wrap: "wrap",
          gap: 1,
          s: {
            mt: 2
          }
        }, status && /*#__PURE__*/React.createElement(Markdown, {
          color: "textSecondary",
          text: status,
          s: {
            mr: 4
          }
        }), type && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          gap: 1,
          wrap: "nowrap",
          s: {
            mr: 4
          }
        }, typeImage && /*#__PURE__*/React.createElement(Picture, {
          width: "1.2rem",
          height: "1.2rem",
          src: typeImage
        }), /*#__PURE__*/React.createElement(Markdown, {
          color: "textSecondary",
          text: type
        })), assignee && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          gap: 1,
          wrap: "nowrap",
          s: {
            mr: 4
          }
        }, assigneeImage && /*#__PURE__*/React.createElement(Picture, {
          width: "1.2rem",
          height: "1.2rem",
          src: assigneeImage
        }), /*#__PURE__*/React.createElement(Markdown, {
          color: "textSecondary",
          text: assignee
        })), priority && /*#__PURE__*/React.createElement(Box, {
          direction: "row",
          gap: 1,
          wrap: "nowrap",
          s: {
            mr: 4
          }
        }, priorityImage && /*#__PURE__*/React.createElement(Picture, {
          width: "1.2rem",
          height: "1.2rem",
          src: priorityImage
        }), /*#__PURE__*/React.createElement(Markdown, {
          color: "textSecondary",
          text: priority
        }))));
      }
    }
    if (botName.toLowerCase().includes("gong")) {
      const isComment = blocks[2]?.type === "context";
      let message;
      let title;
      let context;
      let recap;
      let keyPoints;
      let nextSteps;
      let allCallsUrl;
      if (isComment) {
        message = blocks[0]?.text?.text;
        title = blocks[1]?.text?.text ? helpers.replaceSlackFormatting(blocks[1].text.text.replace(":telephone_receiver:", "📞")) : undefined;
        context = blocks[2]?.elements?.[0]?.text ? helpers.replaceSlackFormatting(blocks[2].elements[0].text) : undefined;
      } else {
        title = blocks[0]?.text?.text ? helpers.replaceSlackFormatting(blocks[0].text.text.replace(":telephone_receiver:", "📞")) : undefined;
        context = blocks[1]?.elements?.[0]?.text ? helpers.replaceSlackFormatting(blocks[1].elements[0].text) : undefined;
        recap = blocks[3]?.text?.text ? helpers.replaceSlackFormatting(blocks[3].text.text) : undefined;
        keyPoints = blocks[5]?.text?.text ? helpers.replaceSlackFormatting(blocks[5].text.text) : undefined;
        nextSteps = blocks[7]?.text?.text ? helpers.replaceSlackFormatting(blocks[7].text.text) : undefined;
        allCallsUrl = blocks[8]?.elements?.[0]?.text ? blocks[8]?.elements[0]?.text.replace("<", "").replace(">").split("|")?.[0] : undefined;
      }
      return /*#__PURE__*/React.createElement(Wrapper, null, message && /*#__PURE__*/React.createElement(Markdown, {
        fontSize: 4,
        display: "block",
        s: {
          mb: 3
        },
        text: message
      }), title && /*#__PURE__*/React.createElement(Markdown, {
        weight: "semiBold",
        fontSize: 4.5,
        lineHeight: 6.5,
        display: "block",
        s: {
          mb: 3
        },
        text: title
      }), context && /*#__PURE__*/React.createElement(Markdown, {
        weight: "semiBold",
        fontSize: 3.5,
        color: "textSecondary",
        display: "block",
        s: {
          mb: 1
        },
        text: context
      }), /*#__PURE__*/React.createElement(Break, null), (recap || keyPoints || nextSteps) && /*#__PURE__*/React.createElement(Collapsable, null, recap && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Markdown, {
        fontSize: 4,
        display: "block",
        text: recap
      }), /*#__PURE__*/React.createElement(Break, {
        s: {
          my: 3
        }
      })), keyPoints && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Markdown, {
        fontSize: 4,
        display: "block",
        text: keyPoints
      }), /*#__PURE__*/React.createElement(Break, {
        s: {
          my: 3
        }
      })), nextSteps && /*#__PURE__*/React.createElement(Markdown, {
        fontSize: 4,
        display: "block",
        text: nextSteps
      })), /*#__PURE__*/React.createElement(Link, {
        href: allCallsUrl,
        fontSize: 4,
        weight: "semiBold"
      }, "All calls"));
    }
  }
  return aiAnalysis?.summary ? /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    fontSize: 4,
    lineHeight: 6.5,
    display: "block",
    s: {
      mt: 3,
      mb: 1
    }
  }, t("TopicFootprintContentSlack.messageSummary")), /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    lineHeight: 6
  }, aiAnalysis.summary)) : null;
};
export default SlackFootprintBotTemplates;